module.exports = __webpack_public_path__ + "img/banner.33db1e42.png";